import db from "../firebase";
import { addDoc, collection } from "@firebase/firestore";

export default function useAnalytics(action, id, optional) {
	const addAnalytics = async () => {
		const _ref_actions = await collection(db, "actions");
		const _optional = !optional ? {} : optional;
		addDoc(_ref_actions, {
			user_id: id,
			action: action,
			analytic_data: _optional,
		});
	};
	return [addAnalytics];
}
